{
  "register-pin-page": {
    "buttons": {
      "resend": "Resend",
      "submit": "Submit"
    },
    "text": {
      "email-check": "TIPS: Please also check your spam folder or check if your email <strong>{{ email }}</strong> is correct or use a different email for registration!",
      "in-second": "in {{seconds}} s",
      "not-receive-pin": "You did not receive any PIN?",
      "pin-incorrect": "PIN is incorrect. Please check it in your email and try again.",
      "verify-account": "Verify your account",
      "verify-account-hint": "The confirmation pin will be sent to your email <strong>{{ email }}</strong>"
    }
  }
}
